export enum PlatformFlagEntities {
    ORG = 'org',
    DOMAIN = 'domain',
    DEMO_DOMAIN = 'demo_domain',
    USER = 'user',
    SEGMENT = 'segment',
}
